var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:DEMAND_PUMP",arg:"DEMAND_PUMP"}],ref:"dataTable",attrs:{"title":"Demand Pump Monitor","url":_vm.api.ACTIONS.DEMAND_PUMP,"fields-hidden-main":[],"enable-delete":false,"enable-add":false,"enable-edit":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }